import type { Plugin } from '@hybridly/core'

export function safeViewTransition(): Plugin {
	if (!document.startViewTransition) {
		return { name: 'safe-view-transition' }
	}

	let domUpdated: ((value?: unknown) => void) | undefined

	return {
		name: 'safe-view-transition',
		navigating: async ({ type, hasDialog }) => {
			if (type === 'initial' || hasDialog) {
				return
			}

			if (document.visibilityState === 'hidden') {
				return
			}

			try {
				return await new Promise((confirmTransitionStarted) => document.startViewTransition(() => {
					confirmTransitionStarted(true)

					return new Promise((resolve) => domUpdated = resolve)
				}))
			} catch {
				domUpdated?.()
				domUpdated = undefined
			}
		},
		mounted: () => {
			domUpdated?.()
			domUpdated = undefined
		},
		navigated: () => {
			domUpdated?.()
			domUpdated = undefined
		},
	}
}
